import { render, staticRenderFns } from "./keyfeature.vue?vue&type=template&id=7854e87a&scoped=true&"
import script from "./keyfeature.vue?vue&type=script&lang=js&"
export * from "./keyfeature.vue?vue&type=script&lang=js&"
import style0 from "./keyfeature.vue?vue&type=style&index=0&id=7854e87a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854e87a",
  null
  
)

export default component.exports